import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { changeURL }  from '@/constants/apis';
import { PRINCIPAL_PAGE } from '@/interfaces/SmartLink/Equipos';
import router from '@/router';
import { useStore }   from 'vuex';

export default /*@__PURE__*/_defineComponent({
  __name: 'PrincipalPageView',
  setup(__props) {

const store     = useStore();

const values:PRINCIPAL_PAGE = {
    0 : [
        process.env.VUE_APP_NAME_PROJECT_CANANEA,
        process.env.VUE_APP_MAP_LAT_CANANEA,
        process.env.VUE_APP_MAP_LNG_CANANEA,
        process.env.VUE_APP_MAP_ZOOM_CANANEA,
    ],
    1 : [
        process.env.VUE_APP_NAME_PROJECT_COLLAHUASI,
        process.env.VUE_APP_MAP_LAT_COLLAHUASI,
        process.env.VUE_APP_MAP_LNG_COLLAHUASI,
        process.env.VUE_APP_MAP_ZOOM_COLLAHUASI,
    ],
}


const cambiarURL = (valor:number) => {
    changeURL(valor)
    router.push('/smartlink/dashboard')
    store.commit('setAppBarPage','smartlinkPage');
    store.commit('setProjectName',values[valor][0]);
    store.commit('setProjectLAT',values[valor][1]);
    store.commit('setProjectLNG',values[valor][2]);
    store.commit('setProjectZOOM',values[valor][3]);
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: "ma-0 prinPage",
    justify: "center",
    style: {"align-content":"center !important","height":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        height: "100",
        color: "red",
        class: "mx-4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (cambiarURL(0)))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("h1", null, "SmartLink Cananea", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        height: "100",
        color: "orange",
        class: "mx-4",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (cambiarURL(1)))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createElementVNode("h1", null, "SmartLink Collahuasi", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})